import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'counter', 'count', 'emptyDisabled', 'plural']

  connect () {
    this.update()
  }

  update () {
    const count = this.checkboxTargets.filter(cb => cb.checked).length

    this.counterTargets.forEach((el) => {
      el.textContent = `(${count})`
    })
    this.countTargets.forEach((el) => {
      el.textContent = String(count)
    })
    this.pluralTargets.forEach((el) => {
      el.textContent = count === 1 ? el.dataset.one : el.dataset.other
    })
    this.emptyDisabledTargets.forEach((el) => {
      el.disabled = count === 0
    })
  }
}
